
const HandleArticleCoverImg = (imgArray, type, size) => {
    if (imgArray){
        return imgArray.find(img => img && img.type === type)["media_details"].sizes[size]["source_url"];
    } else {
        return null
    }
};

export default HandleArticleCoverImg;